<div class="container-fluid recommendation-container">
  <form #mdf="ngForm">
    <div class="row m-0">
      <div class="col-md-6">
        <div class="recommendation-card positive-card">
          <div class="card-header positive-header d-flex justify-content-between align-items-center">
            <span><i class="fa fa-thumbs-up mr-2"></i>Positive</span>
          </div>
          <div class="card-body">
            <div *ngIf="PositiveRemarks.length === 0" class="text-muted text-center py-3">No positive remarks added yet</div>
            <div class="remark-item" *ngFor="let item of PositiveRemarks; let i = index">
              <span class="remark-text">{{ item.remark }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="recommendation-card negative-card">
          <div class="card-header negative-header d-flex justify-content-between align-items-center">
            <span><i class="fa fa-thumbs-down mr-2"></i>Negative</span>
          </div>
          <div class="card-body">
            <div *ngIf="NegativeRemarks.length === 0" class="text-muted text-center py-3">No negative remarks added yet</div>
            <div class="remark-item" *ngFor="let item of NegativeRemarks; let i = index">
              <span class="remark-text">{{ item.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <ng-container *ngIf="hasRemarks">
      <div class="row m-0 mt-3">
        <div class="col-md-12">
          <span class="required-lable">Final Remark</span>
          <textarea #refFinalRemark="ngModel" rows="2" name="FinalRemark" id="FinalRemark" [(ngModel)]="FinalRemark" required disabled
          class="form-control input-text-css" placeholder="Enter final remark..."></textarea>
        </div>
      </div>
      <div class="row m-0 mt-3">
        <div class="col-md-6">
          <span class="required-lable">Recommendation Type</span>
          <select #refRecommendationType="ngModel" name="RecommendationType" id="RecommendationType" [(ngModel)]="RecommendationType" required disabled
            class="form-control input-text-css">
            <option value="">Select Recommendation Type</option>
            <option *ngFor="let type of RecommendationTypes" [value]="type.id">{{ type.value }}</option>
          </select>
        </div>
      </div>
    </ng-container>
  </form>
</div>